<fieldset>
    <legend>Edit Program Detail {{ detailData.id }}</legend>
    <form [formGroup]="detailForm" (ngSubmit)="onSubmit()">
        <div class="control-row">
            <mat-form-field appearance="outline" class="control">
                <mat-label for="id">Id</mat-label>
                <input matInput type="text" formControlName="id" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="control">
                <mat-label for="shortName">Short Name</mat-label>
                <input matInput type="text" formControlName="shortName" />
            </mat-form-field>
        </div>

        <div class="control-row">
            <mat-form-field appearance="outline" class="control">
                <mat-label for="longName">Long Name</mat-label>
                <input matInput type="text" formControlName="longName" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="control">
                <mat-label for="hours">Hours</mat-label>
                <input matInput type="number" formControlName="hours" />
            </mat-form-field>
        </div>

        <div class="control-row">
            <div class="control">
                <mat-label for="enableSurvey" id="enableSurvey">Enable Survey?</mat-label>
                <mat-checkbox formControlName="enableSurvey" color="primary"></mat-checkbox>
            </div>

            <mat-form-field appearance="outline" class="control">
                <mat-label for="surveyType">Survey Type</mat-label>
                <input matInput type="text" formControlName="surveyType" />
            </mat-form-field>
        </div>

        <div class="control-row">
            <mat-form-field appearance="outline" class="control">
                <mat-label for="surveyGroup">Survey Group</mat-label>
                <input matInput type="text" formControlName="surveyGroup" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="control">
                <mat-label for="surveyTrigger">Survey Trigger</mat-label>
                <input matInput type="text" formControlName="surveyTrigger" />
            </mat-form-field>
        </div>

        <div class="control-row">
            <mat-form-field appearance="outline" class="control">
                <mat-label for="surveyIdentifier">Survey Identifier</mat-label>
                <input matInput type="text" formControlName="surveyIdentifier" />
            </mat-form-field>
        </div>

        <div class="button-row">
            <button type="button" mat-raised-button color="primary" (click)="closeDialog({ isChangeComplete: false })">Cancel</button>
            <button type="submit" mat-raised-button color="primary">Save</button>
        </div>
    </form>
</fieldset>